import AlbumsList from "../../../pages/music/album/List";
import AlbumsCreate from "../../../pages/music/album/Create";
import AlbumsEdit from "../../../pages/music/album/Edit";
import {getMusicAlbumCreateRoute, getMusicAlbumEditRoute, getMusicAlbumsRoute} from "./factory/album";

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
    {
        path: getMusicAlbumsRoute(),
        component: AlbumsList,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getMusicAlbumCreateRoute(),
        component: AlbumsCreate,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getMusicAlbumEditRoute(),
        component: AlbumsEdit,
        exact: false,
        type: 'route',
        loginRequired: true,
    },
];

export default routes;